module.exports = __webpack_public_path__ + "img/NASSAU_FLAT.7cc0bf2b.png";